export default {
  namespaced: true,
  state: {
    currency: 'PLN',
    ratio: 1,
    ratioUSD: 1,
    ratioEUR: 1
  },
  mutations: {
    setCurrency(state, currencyCode) {
      if (currencyCode === 'PLN') {
        state.currency = currencyCode;
        state.ratio = 1;
      } else if (currencyCode === 'EUR') {
        state.currency = 'EUR';
        state.ratio = 1; //parseFloat(state.ratioEUR);
      } else if (currencyCode === 'USD') {
        state.currency = 'USD';
        state.ratio = 1; //parseFloat(state.ratioUSD);
      }
    },
    setCurrencyEUR(state, value) {
      state.ratioEUR = value;
    },
    setCurrencyUSD(state, value) {
      state.ratioUSD = value;
    },
  },
  getters: {
      currentCurrency: state => state.currency
  },
}
